import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { DatePipe } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { Router } from '@angular/router';
  
  import { AdoptionService } from '../../services/adoption.service';
  import { PaginationComponent } from '../ui/pagination/pagination.component';
  
  @Component({
    selector: 'app-adoption-list',
    templateUrl: './adoption-list.html',
    styleUrl: './adoption-list.scss',
    imports: [DatePipe, FormsModule, PaginationComponent],
  })
  export class AdoptionListComponent implements OnInit {
    private adoptionService = inject(AdoptionService);
    private cdr = inject(ChangeDetectorRef);
    private router = inject(Router);
  
    adoptions: any[] = [];
    page = 1;
    pageSize = 6;

    get pagedAdoptions(): any[] {
      const start = (this.page - 1) * this.pageSize;
      return this.adoptions.slice(start, start + this.pageSize);
    }

    isLoading = true;
  
    ngOnInit(): void {
      this.loadAdoptions();
    }
  
    loadAdoptions(): void {
      this.isLoading = true;
  
      this.adoptionService.getAllAdoptions().subscribe({
        next: (response: any) => {
          console.log('🟢 ADOPCIONES RECIBIDAS:', response);
  
          this.adoptions = response.data.documents;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR CARGANDO ADOPCIONES:',
            error,
          );
  
          this.adoptions = [];
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }
  
    viewAdoption(id: string): void {
      this.router.navigate(['/admin/adoptions', id]);
    }

    copyAdoptionFormLink(): void {
        const formUrl =
          `${window.location.origin}/formularios/adopciones`;
      
        navigator.clipboard.writeText(formUrl).then(() => {
          alert('Formulario copiado correctamente');
        });
      }
  }